// extracted by mini-css-extract-plugin
export default {"attitude":"Monitor3_attitude__vyvPz"};